export var SHOW = '@redux-modal/SHOW';
export var HIDE = '@redux-modal/HIDE';
export var DESTROY = '@redux-modal/DESTROY';